import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SeasonComponent } from '../Components/season/season.component';
import { CourseComponent } from '../Components/course/course.component';
import { RunComponent } from '../Components/run/run.component';
import { NewSeasonComponent } from '../Components/season/new-season/new-season.component';
import { NewCourseComponent } from '../Components/course/new-course/new-course.component';
import { NewRunComponent } from '../Components/run/new-run/new-run.component';
import { SeasonsListComponent } from '../Components/seasonsList/seasons.component';
import { CompareComponent } from '../Components/compare/compare.component';

const routes: Routes = [
  { path: 'season/new', component: NewSeasonComponent },
  { path: 'season/:seasonId', component: SeasonComponent },
  { path: 'season/:seasonId/course/new', component: NewCourseComponent },
  { path: 'season/:seasonId/course/:courseId', component: CourseComponent },
  { path: 'season/:seasonId/course/:courseId/run/new', component: NewRunComponent },
  { path: 'season/:seasonID/course/:courseId/run/:runId', component: RunComponent },
  { path: 'season/:seasonID/course/:courseId/run/:runId/compare/:ninjaId', component: CompareComponent },
  { path: '', component: SeasonsListComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { enableTracing: false })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
